module.exports = __webpack_public_path__ + "static/img/三大产品.a94d747.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/三大产品.png
// module id = iy74
// module chunks = 3